import React, { useState, useContext, useEffect } from 'react'
import { ProfileLayout } from "../layout"
import css from "./address.module.scss"
import { Checkbox } from '../../../componentsV1/Checkbox'
import { AuthContext } from '../../../context/auth'
import { updateCustomerAddressesApi, currentUserApi, updateCustomerApi } from '../../../api'
import { countryCode, getKeyByValue } from '../../../utils/country'

export const BillingAddress = () => {
    const { setNotification, setBillingAddressModal, setSelectedAddress, user, setUser, setIsLoading } = useContext(AuthContext)
    const [address, setAddress] = useState([])


    const fetchCurrentUser = () => {
        setIsLoading(true)
        currentUserApi()
            .then(res => {
                if (res.data) {
                    setUser(res.data)
                    setIsLoading(false)
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }



    useEffect(() => {
        setAddress(user?.customer?.shipping_addresses?.filter((item) => item.metadata?.type === 'billing'))

    }, [user])


    const handlePrimary = (addr) => {
        setIsLoading(true)
        if (address.length > 1) {
            address?.map((item) => {
                Promise.all([updateCustomerAddressesApi(item.id,
                    item.id == addr.id ? {
                        metadata: {
                            ...item.metadata,
                            is_primary: true
                        }
                    } : {
                        metadata: {
                            ...item.metadata,
                            is_primary: false
                        }
                    }
                )]).then(() => {
                    setNotification({
                        type: 'success',
                        message: 'Primary Billing Address Updated!'
                    })
                    updateCustomerApi({
                        billing_address: {
                            first_name: addr.first_name,
                            last_name: "",
                            company: addr.company,
                            address_1: addr.address_1,
                            city: addr.city,
                            province: addr.province,
                            country_code: addr.country_code,
                            postal_code: addr.postal_code,
                            metadata: {
                                ...addr.metadata,
                                is_primary: true
                            }
                        }
                    })
                    fetchCurrentUser()
                    setIsLoading(false)
                }).catch(() => {
                    setIsLoading(false)
                    setNotification({
                        type: 'red',
                        message: 'Something went wrong, please try again!'
                    })
                })
            })
        } else {
            setNotification({
                type: 'red',
                message: 'One Primary Billing Address is required!'
            })
            setIsLoading(false)
        }
    }


    return (
        <ProfileLayout>
            <div className={css.wrapper}>
                <div className={css.header}>
                    <h4>Billing Address</h4>
                    <button className={css.link} onClick={() => {
                        setBillingAddressModal(true)
                        setSelectedAddress(null)
                    }}><i className='far fa-plus'></i> Add New</button>
                </div>
                <div className={css.addressContainer}>
                    {address && address.length > 0 ?
                        address?.map((item) => {
                            return (
                                <div className={css.addressCard} key={item.id}>
                                    <div className={css.leftContainer}>
                                        <h5>{item.company} {item.metadata?.is_primary && <span>Primary</span>}</h5>
                                        <p>{item.address_1}, {item.city}, {item.province} {item.postal_code}, {getKeyByValue(countryCode, item?.country_code?.toUpperCase())}</p>
                                        <Checkbox label={'Make Primary'} checked={item?.metadata?.is_primary} onChange={() => handlePrimary(item)} isCustom />
                                    </div>
                                    <div className={css.rightContainer}>
                                        <button className={css.link} style={{ fontSize: '16px' }} onClick={() => {
                                            setBillingAddressModal(true)
                                            setSelectedAddress(item)
                                        }} >Edit</button>
                                    </div>
                                </div>
                            )
                        })
                        : <div className={css.noItems}>
                            <span className='icon'>
                                <i class="fal fa-boxes"></i>
                            </span>
                            <p>No Billing Address Yet.</p>
                        </div>
                    }
                </div>
            </div>
        </ProfileLayout>
    )
}